import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=0f63b1d6&"
import script from "./Total.vue?vue&type=script&lang=js&"
export * from "./Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports